import {
  LandingPageCustom,
  landingPageCustomSchema,
  type LandingPageCustomProps,
} from '../../components/LandingPageCustom';
import { serverLogger } from '../../utils/loggers/server';
import { getCachedEntryByUrl } from '../../utils/requests/contentstack/cachedRequests';

export const getStaticProps = async () => {
  try {
    const entry = await getCachedEntryByUrl({
      contentType: 'landing_page_custom',
      url: '/women/activewear',
      schema: landingPageCustomSchema,
      logger: serverLogger,
    });

    return {
      props: entry.data,
      revalidate: 300,
    };
  } catch (error) {
    serverLogger({
      level: 'error',
      team: 'client-onboarding',
      message: 'Failed to fetch required page data - /women/activewear',
      context: {
        error,
        page: '/women/activewear',
        severity: 'critical',
      },
    });

    throw new Error('Required data not provided to render /women/activewear');
  }
};

const ActivewearPage = ({ seoData, modules }: LandingPageCustomProps) => {
  return <LandingPageCustom seoData={seoData} modules={modules} />;
};

export default ActivewearPage;
